import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import {Checkbox, Dialog, DialogActions, DialogContent, Tooltip} from "@mui/material";
import ButtonAdd from "../button/ButtonAdd";
import ButtonCancel from "../button/ButtonCancel";
import React, {useEffect, useState} from "react";
import MaterialTree from "../tree/MaterialTree";
import TextFieldValidation from "../table/customer-detales/TextFieldValidation";
import MenuItem from "@mui/material/MenuItem";
import UserJobMetricPackingMaterial from "../../../API/material-cloud/user/UserJobMetricPackingMaterial";


export const ModalSelectAction = ({
                                      open,
                                      reset,
                                      submit,
                                      modalActions,
                                      dataTree,
                                      handleModalAlert,
                                      materialId,
                                      width = "400px",
                                      supplierList,
                                      fillReserveDisabled,
                                      ignoreSlab,
                                      ignoreTypes,
                                      loading
                                  }) => {
    const [selectedType, setSelectedType] = useState(modalActions[0]?.type)
    const [currentGroup, setCurrentGroup] = useState(null)
    const [packings, setPackings] = useState([])
    const [formState, setFormState] = useState({packing: "", margin: "", supplier: "", ignoreSlab: true})
    const [expandedItems, setExpandedItems] = useState(['M']);

    const handleExpandedItemsChange = (event, itemIds) => {
        setExpandedItems(itemIds);
    };

    const handleToggle = (node) => {
        // let id = node?.id
        //
        // const group = groupMap.get(id) || {}
        // if (group !== null) {
        //     GroupMaterialUtil.addToFilterMapGroup(group, filterGroup)
        //     setFilterGroup(filterGroup);
        //     setChangeFilterGroup(!changeFilterGroup)
        //     changeCurrentGroup(group)
        // }
    };

    useEffect(() => {
        setSelectedType(modalActions[0]?.type)
    }, [modalActions])
    useEffect(() => {
        materialId && open && UserJobMetricPackingMaterial.getById(materialId)
            .then(function (response) {
                setPackings(response.data)
                setFormState({packing: response.data[0]?.id})
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
    }, [])
    const handleCancel = () => {
        setCurrentGroup(null)
        setSelectedType(modalActions[0].type)
        setFormState(prev => ({...prev, margin: "", supplier: "", ignoreSlab: true}))
        reset()
    }
    const handleAdd = () => {
        (ignoreTypes?.includes(selectedType) && ignoreSlab) ? submit(selectedType, formState.ignoreSlab, handleCancel) : selectedType === "editSupplier" ? submit(selectedType, formState.supplier, handleCancel) : selectedType === "addPackaging" ? submit(selectedType, formState.packing, handleCancel) : selectedType === "setDefaultMargin" ? submit(selectedType, formState.margin, handleCancel) : submit(selectedType, currentGroup?.id, handleCancel)
    }
    return <Dialog open={open} PaperProps={{
        style: {
            minWidth: width,
            borderRadius: 8,
            padding: 16,
            paddingTop: 0,
            boxSizing: "border-box"
        }
    }}>
        <DialogContent style={{display: "flex", flexDirection: "column", padding: "24px 0"}}>
            <RadioGroup
                defaultValue="female"
                aria-labelledby="demo-customized-radios"
                name="customized-radios"
                value={selectedType}
                onChange={(event) => setSelectedType(event.target.value)}
            >
                {modalActions.map((option) => (
                        <React.Fragment key={option.type}>
                            <FormControlLabel
                                value={option.type}
                                control={<Radio/>}
                                label={option.name}
                                disabled={option.disabled}
                                sx={{
                                    margin: 0,
                                    height: "36px",
                                    "&:not(:last-of-type)": {
                                        marginBottom: "4px",
                                    },
                                    borderBottom: (theme) => `${theme.palette.primary.stroke} solid 1px`,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light
                                    }
                                }
                                }
                            />
                            {(option.type === selectedType && ignoreTypes?.includes(selectedType) && ignoreSlab) &&
                                <FormControlLabel control={<Checkbox
                                    checked={formState.ignoreSlab}
                                    onChange={() => setFormState(value => ({
                                        ...value,
                                        "ignoreSlab": !value.ignoreSlab
                                    }))}
                                    sx={{marginLeft: "20px"}}
                                />} label="Игнорировать плитные"/>}
                        </React.Fragment>
                    )
                )}
            </RadioGroup>
            {
                selectedType === "setGroup" && <MaterialTree
                    name={"Группы"}
                    data={dataTree}
                    currentGroup={currentGroup}
                    setCurrentGroup={setCurrentGroup}
                    readOnly={true}
                    handleToggle={handleToggle}
                    expandedItems={expandedItems}
                    handleExpandedItemsChange={handleExpandedItemsChange}
                />
            }
            {
                selectedType === "setDefaultMargin" && <TextFieldValidation
                    name={"margin"}
                    label={"Наценка"}
                    value={formState?.margin}
                    setCurrValues={setFormState}
                />
            }
            {
                selectedType === "addPackaging" && <TextFieldValidation
                    select
                    name="packing"
                    label="Упаковка"
                    value={formState.packing}
                    setCurrValues={setFormState}
                >
                    {packings.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.name}
                        </MenuItem>
                    ))}
                </TextFieldValidation>
            }
            {
                selectedType === "editSupplier" && <TextFieldValidation
                    select
                    name="supplier"
                    label="Поставщик"
                    value={formState.supplier}
                    setCurrValues={setFormState}
                >
                    {supplierList.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.name}
                        </MenuItem>
                    ))}
                </TextFieldValidation>
            }

        </DialogContent>
        <DialogActions style={{display: "flex", justifyContent: "space-between", padding: 0}}>
            <ButtonCancel text={"Отменить"} onClick={handleCancel}/>
            <Tooltip
                arrow placement="top"
                title={fillReserveDisabled && selectedType === "fillReserve" ? "У выбранных резервов разные материалы" : ""}>
                 <span>
                <ButtonAdd
                    loading={loading}
                    text={"Применить"}
                    disabled={(!currentGroup && selectedType === "setGroup") || (formState?.margin?.length === 0 && selectedType === "setDefaultMargin") || (fillReserveDisabled && selectedType === "fillReserve")}
                    width={176}
                    height={56} onClick={handleAdd}/>
                 </span>
            </Tooltip>
        </DialogActions>
    </Dialog>
}